import services from '@/services.js'

export default {
  setCurrentStep: ({ commit }, number) => {
    commit('SET_CURRENT_STEP', number)
  },

  updateInfoStep: ({ commit }, data) => {
    commit('SET_INFO_STEP', data)
  },

  updateInfoPropStep: ({ commit }, prop, data) => {
    commit('SET_PROP_INFO_STEP', prop, data)
  },

  removeCartItem: ({ commit }, data) => {
    commit('REMOVE_CART_ITEM', data)
  },

  clearCart: ({ commit }, data) => {
    commit('CLEAR_CART', data)
  },

  setModalComponent: ({ commit }, data) => {
    commit('SET_MODAL', data)
  },

  closeModalComponent: ({ commit }) => {
    commit('CLOSE_MODAL')
  },

  successPurcharse: ({ commit }) => {
    commit('RESET_STATE_STEP')
  },

  validateBillingInfo: ({ commit }, { prop, info, organizationId }) => {
    return new Promise((resolve, reject) => {
      services
        .validatebillinginfo(organizationId, info)
        .then(({ data }) => {
          commit('SET_COSTUMER', data.data)
          commit('SET_PROP_INFO_STEP', { prop, data: info })
          resolve(true)
        })
        .catch((error) => {
          reject(error.response)
        })
    })
  },

  createPaymentIntent: ({ commit }, { info, organizationId }) => {
    return new Promise((resolve, reject) => {
      services
        .createpaymentintent(organizationId, info)
        .then(({ data }) => {
          commit('SET_CURRENT_STEP', 4)
          resolve(true)
        })
        .catch((error) => {
          reject(error.response)
        })
    })
  },

  balancetax: ({ commit }, { info, organizationId }) => {
    return new Promise((resolve, reject) => {
      services
        .balancetax(organizationId, info)
        .then(({ data }) => {
          commit('SET_CURRENT_STEP', 4) 
          commit('SET_PROP_INFO_STEP', { prop: 'iva', data: data.data.iva })
          resolve(true)
        })
        .catch((error) => {
          reject(error.response)
        })
    })
  },
}
